(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        class ERKProjectHeroNav extends HTMLElement {
            constructor() {
                super();
                this.links = [];
                this.navAnchor = null;
                this.navShell = null;
                this.headerSection = null;
                this.resizeObserver = null;
                this.animationFrameId = 0;
                this.handleLinkClick = this.handleLinkClick.bind(this);
                this.handleViewportChange = this.handleViewportChange.bind(this);
            }
            connectedCallback() {
                this.links = Array.from(this.querySelectorAll(".erk-project-hero-nav__link[data-target-id]"));
                this.navAnchor = this.querySelector(".erk-project-hero-nav__nav-anchor");
                this.navShell = this.querySelector(".erk-project-hero-nav__nav-shell");
                this.headerSection = document.querySelector(".shopify-section--header");
                if (this.isStickyBelowHeaderEnabled()) {
                    this.setupStickyBelowHeader();
                }
                if (!this.links.length) {
                    return;
                }
                this.links.forEach((link => {
                    link.addEventListener("click", this.handleLinkClick);
                }));
            }
            disconnectedCallback() {
                this.links.forEach((link => {
                    link.removeEventListener("click", this.handleLinkClick);
                }));
                this.teardownStickyBelowHeader();
            }
            isStickyBelowHeaderEnabled() {
                return this.dataset.stickBelowHeader === "true";
            }
            setupStickyBelowHeader() {
                this.requestStickyOffsetUpdate();
                window.addEventListener("scroll", this.handleViewportChange, {
                    passive: true
                });
                window.addEventListener("resize", this.handleViewportChange);
                if ("ResizeObserver" in window) {
                    this.resizeObserver = new ResizeObserver((() => {
                        this.requestStickyOffsetUpdate();
                    }));
                    if (this.headerSection instanceof HTMLElement) {
                        this.resizeObserver.observe(this.headerSection);
                    }
                    if (this.navShell instanceof HTMLElement) {
                        this.resizeObserver.observe(this.navShell);
                    }
                }
            }
            teardownStickyBelowHeader() {
                window.removeEventListener("scroll", this.handleViewportChange);
                window.removeEventListener("resize", this.handleViewportChange);
                this.classList.remove("erk-project-hero-nav--floating");
                if (this.resizeObserver) {
                    this.resizeObserver.disconnect();
                    this.resizeObserver = null;
                }
                if (this.animationFrameId) {
                    window.cancelAnimationFrame(this.animationFrameId);
                    this.animationFrameId = 0;
                }
            }
            handleViewportChange() {
                this.requestStickyOffsetUpdate();
            }
            requestStickyOffsetUpdate() {
                if (this.animationFrameId) {
                    return;
                }
                this.animationFrameId = window.requestAnimationFrame((() => {
                    this.animationFrameId = 0;
                    this.updateStickyOffset();
                }));
            }
            updateStickyOffset() {
                const headerBottomOffset = this.getHeaderBottomOffset();
                this.style.setProperty("--erk-project-hero-nav-sticky-top", `${headerBottomOffset}px`);
                this.updateNavShellHeight();
                this.updateFloatingState(headerBottomOffset);
            }
            updateNavShellHeight() {
                if (!(this.navShell instanceof HTMLElement)) {
                    return;
                }
                this.style.setProperty("--erk-project-hero-nav-nav-shell-height", `${this.navShell.offsetHeight}px`);
            }
            updateFloatingState(headerBottomOffset) {
                if (!(this.navAnchor instanceof HTMLElement) || !(this.navShell instanceof HTMLElement)) {
                    this.classList.remove("erk-project-hero-nav--floating");
                    return;
                }
                const shouldFloat = this.navAnchor.getBoundingClientRect().top <= headerBottomOffset;
                this.classList.toggle("erk-project-hero-nav--floating", shouldFloat);
            }
            getHeaderBottomOffset() {
                const rootStyles = window.getComputedStyle(document.documentElement);
                const headerHeightValue = rootStyles.getPropertyValue("--header-height");
                const headerHeight = Number.parseFloat(headerHeightValue);
                if (Number.isFinite(headerHeight) && headerHeight > 0) {
                    return Math.round(headerHeight);
                }
                if (!(this.headerSection instanceof HTMLElement)) {
                    this.headerSection = document.querySelector(".shopify-section--header");
                }
                if (!(this.headerSection instanceof HTMLElement)) {
                    return 0;
                }
                const headerStyles = window.getComputedStyle(this.headerSection);
                const isStickyHeader = headerStyles.position === "sticky" || headerStyles.position === "fixed";
                if (!isStickyHeader) {
                    return 0;
                }
                const headerRect = this.headerSection.getBoundingClientRect();
                return Math.max(0, Math.round(headerRect.bottom));
            }
            getScrollOffset() {
                const defaultOffset = 100;
                const fallbackOffset = Number(this.dataset.scrollOffset || defaultOffset);
                if (!this.isStickyBelowHeaderEnabled() || !(this.navShell instanceof HTMLElement)) {
                    return fallbackOffset;
                }
                return this.getHeaderBottomOffset() + this.navShell.offsetHeight;
            }
            handleLinkClick(event) {
                const link = event.currentTarget;
                const targetId = link instanceof HTMLElement ? link.dataset.targetId : "";
                const target = this.getTargetElement(targetId);
                if (!target) {
                    return;
                }
                event.preventDefault();
                this.scrollToTarget(target);
            }
            getTargetElement(targetId) {
                if (!targetId) {
                    return null;
                }
                const target = document.getElementById(targetId);
                return target instanceof HTMLElement ? target : null;
            }
            scrollToTarget(target) {
                const offsetValue = this.getScrollOffset();
                const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - offsetValue;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }
        if (!window.customElements.get("erk-project-hero-nav")) {
            window.customElements.define("erk-project-hero-nav", ERKProjectHeroNav);
        }
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();